module.exports = __webpack_public_path__ + "img/step4-fr.8b327d37.webp";